<div class="tab-block">
    <div class="invitation-section-wrapper">
        @if (enableInvitationBlock) {
            <div class="send-invitations-wrapper">
                <h4>
                    {{ TR.key('userManagement.sendInvitations-header') }}
                </h4>
                <p>
                    {{ getInvitationsDescriptionText() }}
                </p>
                <div>
                    <pi-module-user-management-invitation
                        #piModuleInvitation
                        (inviteUsersEvent)="refreshGridData()"
                        [moduleName]="moduleName"
                    >
                    </pi-module-user-management-invitation>
                </div>
                <mat-divider></mat-divider>
            </div>
        }
        <div class="manage-users-wrapper">
            <h4 class="invitation-user-grid-header">
                {{ TR.key('userManagement.user-grid.access-header') }}
            </h4>
            <p>
                {{ TR.key('userManagement.manageModules-description') }}
            </p>
            <pi-module-user-management-grid
                #piModuleManageUsers
                [moduleName]="moduleName"
            ></pi-module-user-management-grid>
        </div>
    </div>
</div>
